import React, { useEffect } from 'react';


import { Link } from 'react-router-dom';
import Sideprofile from '../assets/img/Icons/Icons/sideprofile-img.png'
import Icon1 from '../assets/img/Icons/Icons/Icon-11.png'

import Icon2 from '../assets/img/Icons/Icons/Icon-12.png'
import Icon3 from '../assets/img/Icons/Icons/Icon-15.png'
import Icon4 from '../assets/img/Icons/Icons/Icon-13.png'
import Icon5 from '../assets/img/Icons/Icons/Icon-14.png'
import Icon6 from '../assets/img/Icons/Icons/Icon-16.png'
import Icon7 from '../assets/img/Icons/Icons/msg1.png'
import Icon8 from '../assets/img/Icons/Icons/SL.png'
import Icon9 from '../assets/img/Icons/Icons/card.png'

// import Barside from '../assets/img/Icons/Icons/Icon-17.png'

import Barside from '../assets/img/Icons/Icons/Icon-17.png'
import Footer from './footer';
const Sidebar = () => {


    useEffect(() => {
        $(document).on("click", ".button-nav, .navigation-backdrop", function () {

            var $nav = $("#navigation-demo");
            var $hasClass = $nav.hasClass("open");

            if (!$hasClass) {
                $nav.addClass("open");
                $("body").append("<div class='navigation-backdrop'></div>");
            } else {
                $nav.removeClass("open");
                $(".navigation-backdrop").remove();
            }

        });

    }, [])


    return (
        <div>



            <div class="main">

                <div class="header-top">
                    <button class="button-nav"><img src={Barside} className="Barside" alt="" />
                    </button>
                </div>

                <div class="navigation" id="navigation-demo">
                    <nav>
                        <div className="bg-light pb-2">
                            <div class="navigation-button">
                                <button class="button-nav border-white"><i class="fa fa-times" style={{ fontSize: "24px" }} aria-hidden="true"></i></button>
                            </div>
                            <div className="text-center">
                                <img src={Sideprofile} className="sidepanel-sidebar " alt="" />
                                <p className="font-weight-bold mt-2">User Name</p>
                            </div>
                        </div>
                      <div>
                      <ul className="list-style-none pl-2">
                            <li><Link to="/Coupens"><img src={Icon1} alt="" className="sidepanel-texts-img" />Coupons</Link></li>
                            <li><Link to="/WeeklyAd"><img src={Icon2} alt="" className="sidepanel-texts-img" />WeeklyAd</Link></li>
                            <li><Link to="/Reaward"><img src={Icon5} alt="" className="sidepanel-texts-img" />Reaward</Link></li>
                            <li><Link to="/Messages"><img src={Icon7} alt="" className="sidepanel-texts-img" />Messages</Link></li>
                            <li><Link to="/List"><img src={Icon8} alt="" className="sidepanel-texts-img" />Shopping List</Link></li>
                            <li><Link to="/CardNew"><img src={Icon9} alt="" className="sidepanel-texts-img" />Card</Link></li>
                            <li><Link to="/Location"><img src={Icon3} alt="" className="sidepanel-texts-img" />Location</Link></li>
                            <li><Link to="/CardNew"><img src={Icon4} alt="" className="sidepanel-texts-img" />About Us</Link></li>
                            <li><Link to="/ContactUs"><img src={Icon6} alt="" className="sidepanel-texts-img" />Contact Us</Link></li>
         
                        </ul>
                      </div>
                    </nav>
                </div>


            </div>

            {/* <div className="bg-white border shadow  bg-bottom-round">
                <div className="container page17 px-3">

                    <div className="col-sm-12">
                        <Link to="/Location">Location</Link><br />
                        <Link to="/Reset15">Reset</Link><br />
                        <Link to="/SandP">Support and Privacy</Link><br />
                        <Link to="/ContactUs">ContactUs</Link><br />

                         <Link to="/List">List</Link><br /> 
                        <Link to="/Reaward">Reawards</Link><br />
                        <Link to="/CoupensDetail">CoupensDetail</Link><br />

                        <Link to="/Checkout">Check out</Link><br />
                        <Link to="/CardNew">CardNew</Link><br />

                        <Link to="/Profile">Profile</Link>

                        <Link to="/Coupens">Coupens</Link>

                        <Link to="/SetNewpin">SetNewpin</Link>
                        <Link to="/EmailPin">EmailPin</Link>
                        <Link to="/SmsPin">SmsPin</Link>

                        <Link to="/SearchResults">SearchResults</Link>

                        <Link to="/Messages">Messages</Link>
                        <Link to="/DealOfWeek">DealOfWeek</Link>
                        <Link to="/WeeklyAd">WeeklyAd</Link>


                    </div>
                </div> 
                </div>*/}

        </div>
    )
}

export default Sidebar;

